import Icon from 'core/modules/atoms/Icon';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import ChatButton from '../ChatButton';
import './ChatD3VisualizationCard.scss';

function ChatD3VisualizationCard({ onOpen, title, url, t }) {
  return (
    <div className="chat-d3-card" onClick={() => onOpen(url, title)}>
      <div className="chat-d3-card__header">
        <div className="chat-d3-card__title">{title}</div>
      </div>
      <div className="chat-d3-card__footer chat-d3-card__footer__content">
        <div className="chat-d3-card__footer__title">
          <Icon type="weblink" color="#828282" />
          {t('chatbot:Interactive')}
        </div>
        <ChatButton variant="text">{t('chatbot:View')}</ChatButton>
      </div>
    </div>
  );
}

ChatD3VisualizationCard.propTypes = {
  onOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation(['chatbot'])(ChatD3VisualizationCard);
